    <kendo-numerictextbox
            [decimals]="0"
            [format]="'n0'"
            [formControl]="control"
            [spinners]="false"
            [changeValueOnScroll]="false">
    </kendo-numerictextbox>
